var map = {
	"./MOXIE.png": 274,
	"./arrow-down-blue.svg": 985,
	"./arrow-down-grey.svg": 986,
	"./arrow-right-white.png": 987,
	"./arrow-right.svg": 988,
	"./avalanche_logo.png": 365,
	"./big_unicorn.png": 366,
	"./blue-loader.svg": 158,
	"./circle-grey.svg": 989,
	"./circle.svg": 990,
	"./coinbaseWalletIcon.svg": 216,
	"./documents.pdf": 991,
	"./dropdown-blue.svg": 992,
	"./dropdown.svg": 993,
	"./dropup-blue.svg": 994,
	"./ethereum-logo.png": 367,
	"./ethereum-logox.png": 368,
	"./fortmaticIcon.png": 217,
	"./link.svg": 995,
	"./magnifying-glass.svg": 996,
	"./menu.svg": 997,
	"./metamask.png": 364,
	"./noise.png": 369,
	"./plus-blue.svg": 998,
	"./plus-grey.svg": 999,
	"./pools/CHLI.png": 1000,
	"./pools/Chilli.png": 1001,
	"./portisIcon.png": 218,
	"./question-mark.svg": 1002,
	"./question.svg": 1003,
	"./quickswap-logo.svg": 185,
	"./quickswap-logo.zip": 1004,
	"./quickswap-quick-seeklogo.com.pdf": 1005,
	"./spinner.svg": 1006,
	"./sushiswap.png": 273,
	"./token-list/lists-dark.png": 1007,
	"./token-list/lists-light.png": 1008,
	"./token-logo.png": 1009,
	"./trustWallet.png": 1010,
	"./uniswap.png": 193,
	"./verified.png": 370,
	"./walletConnectIcon.svg": 219,
	"./x.svg": 1011,
	"./xl_uni.png": 371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 332;